










































































export default {
    props: {
        value: Object,
        lists: Object,
        nazione: String,
    },
    data(this: any): any {
        const checkArea = (rule : any, value: string, callback: any) => {
            if (this.nazione === 'IT' && (value === '' || value == null)) {
                callback(new Error(this.$t('masterDataFromRules.Required').toString()));
            }
            callback();
        };
        return {
            rules: {
                Address1: [
                    { required: true, message: this.$t('masterDataFromRules.Required'), trigger: ['blur', 'change'] },
                ],
                ZIP: [
                    { required: true, message: this.$t('masterDataFromRules.Required'), trigger: ['blur', 'change'] },
                ],
                City: [
                    { required: true, message: this.$t('masterDataFromRules.Required'), trigger: ['blur', 'change'] },
                ],
                Area: [
                    { validator: checkArea, trigger: ['blur', 'change'] },
                    {
                        min: 0, max: 2, message: this.$t('masterDataFromRules.Area'), trigger: ['blur', 'change'],
                    },
                ],
                Email: [
                    { required: true, message: this.$t('masterDataFromRules.Required'), trigger: ['blur', 'change'] },
                    { type: 'email', message: this.$t('masterDataFromRules.Email'), trigger: ['blur', 'change'] },
                ],
                Phone: [
                    { required: true, message: this.$t('masterDataFromRules.Required'), trigger: ['blur', 'change'] },
                ],
                Lingua: [
                    { required: true, message: this.$t('masterDataFromRules.RequiredSelect'), trigger: ['blur', 'change'] },
                ],
            },
        };
    },
    methods: {
        next(this: any) {
            this.$refs.form.validate((valid: any) => {
                if (valid) {
                    this.$emit('next');
                }
            });
        },
        back(this: any) {
            this.$refs.form.clearValidate();
            this.$emit('back');
        },
    },
};
